export function reactionCount(count: number): string {
  if (!Number.isFinite(count) || count <= 0) return "0";

  const format = (value: number, suffix: string) => {
    const rounded = Math.floor(value * 10) / 10;
    const trimmed = rounded % 1 === 0 ? String(rounded) : rounded.toFixed(1);
    return `${trimmed}${suffix}`;
  };

  if (count >= 1_000_000) return format(count / 1_000_000, "M");
  if (count >= 1_000) return format(count / 1_000, "K");
  return String(count);
}
